import 'styles/navbar.css'
import logoUmss from 'assets/images/logoUmss.png'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { PrivateRoutes, PublicRoutes, SharedRoutes } from 'routes/rutas'
import Avatar from './Avatar'
import { BsArrowBarRight, BsGear, BsPersonFill, BsQuestionCircle } from 'react-icons/bs'
import { clearTeacher } from 'redux/states/docente'
import { clearLoginData } from 'redux/states/authSlice'
import { APISERVICE } from 'services/api.service'

const linksByUser = {
    administrador: [
        { path: PrivateRoutes.ADMINISTRACION, label: 'Administración' },
        { path: PrivateRoutes.PERIODO, label: 'Periodo' },
        { path: PrivateRoutes.HABILITARDOCENTE, label: 'Habilitar Docente' },
        { path: PrivateRoutes.REPORTES, label: 'Reportes' },
        { path: PrivateRoutes.JUSTFICACIONES, label: 'Justificaciones' },
    ],
    uti: [
        { path: PrivateRoutes.REPORTES, label: 'Reportes' },
        { path: PrivateRoutes.JUSTFICACIONES, label: 'Justificaciones' },
    ],
    docente: [
        { path: PrivateRoutes.HOMETEACHER, label: 'Control Asistencia', end: true },
        { path: PrivateRoutes.REPORTETEACHER, label: 'Reporte', end: true },
    ],
    '': [],
}

const labelRoles = {
    administrador: 'Administrador',
    uti: 'UTI',
    docente: 'Docente',
}

export default function Navbar() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user, roles, isLogged } = useSelector((state) => state.auth)
    const role = roles.length > 0 ? roles[0] : ''

    const handleLogout = async () => {
        await APISERVICE.get('usuario/logout', '')
        dispatch(clearLoginData())
        dispatch(clearTeacher())
        navigate(PublicRoutes.LOGIN)
    }

    return (
        <nav className='navbar navbar-expand-lg bg-body-tertiary header-bg px-md-5 py-3'>
            <div className='container-fluid'>
                <div className='rounded' style={{ width: '8rem' }}>
                    <img src={logoUmss} alt='imagen' className='w-100 rounded' />
                </div>
                <button
                    className='navbar-toggler'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#navbarTeacher'
                    aria-controls='navbarTeacher'
                >
                    <span className='navbar-toggler-icon text-white'></span>
                </button>
                <div className='collapse navbar-collapse' id='navbarTeacher'>
                    <ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
                        {linksByUser[role].map((link) => (
                            <li key={link.path} className='nav-item'>
                                <NavLink
                                    className='nav-link'
                                    to={link.path}
                                    {...(typeof link.end === 'boolean' && { end: link.end })}
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                        <li className='nav-item d-lg-none'>
                            <button className='nav-link' onClick={handleLogout}>
                                Cerrar sesión
                            </button>
                        </li>
                    </ul>
                </div>
                {isLogged && (
                    <div className='navbar-nav d-none d-lg-flex'>
                        <div className='text-center text-white border-start px-3 ms-3' style={{ lineHeight: 1.2 }}>
                            <div>{user.username}</div>
                            <div className='fw-bold'>{labelRoles[role]}</div>
                        </div>
                        <div className='dropdown'>
                            <div data-bs-toggle='dropdown'>
                                <Avatar className='cursor-pointer'>
                                    <BsPersonFill style={{ width: '1.5rem', height: '1.5rem', fill: '#9b0f21' }} />
                                </Avatar>
                            </div>
                            <ul className='dropdown-menu dropdown-menu-end user-select-none'>
                                <li>
                                    <Link to={SharedRoutes.AYUDA} className='dropdown-item cursor-pointer'>
                                        <BsQuestionCircle className='me-2' /> Ayuda
                                    </Link>
                                </li>
                                {role !== 'administrador' && (
                                    <li>
                                        <Link to={PrivateRoutes.SETTINGS} className='dropdown-item cursor-pointer'>
                                            <BsGear className='me-2' /> Configuración
                                        </Link>
                                    </li>
                                )}
                                <li className='dropdown-item cursor-pointer' onClick={handleLogout}>
                                    <BsArrowBarRight className='me-2' /> Cerrar sesión
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    )
}
